export default __webpack_public_path__ + "static/media/jpg.f8e8eaaf.svg";